<template>
  <img
    alt="Race Lens"
    height="12"
    src="@/assets/images/logo.svg"
    width="32"
  />
</template>

<script>
export default {
  name: 'AppLogo',
};
</script>
